var map = {
	"./Bronze.svg": 880,
	"./Diamond.svg": 881,
	"./Gold.svg": 882,
	"./Silver.svg": 883,
	"./company-default.png": 154,
	"./dummy.jpg": 215,
	"./dummy_profile.jpg": 111,
	"./icons8-whatsapp.svg": 83,
	"./invoice-sign": 255,
	"./invoice-sign.js": 255,
	"./videoimg.png": 267
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 210;